enum tipoConselhoRegional {
    CRMV = 0,
    CRM = 1,
    CRO = 2,
    CRN = 3,
    CRF = 4,
    Outro = 5
}

export default tipoConselhoRegional;